<template>
  <div>
    <QExpansionItem
      expand-separator
      :label="labelEntityDetails"
      :header-style="{
        color: 'var(--primary-color)',
        fontWeight: 500,
        paddingLeft: '0px',
        borderBottom: '1px solid #ccc8c8',
        marginBottom: '20px'
      }"
      :disable="disableCollapse"
      v-model="openEntityDetails"
    >
      <QForm @submit.prevent="onSubmitEntityDetails">
        <div class="row">
          <!-- <InputField label="Company Legal Name*" v-model="entityDetails.name" :readonly="true" /> -->

          <InputField label="Legal Business Name*" v-model="entityDetails.name" :readonly="true" />

          <div class="q-pa-xs col-12 col-sm-6">
            <!-- <label class="field-label">Company Legal Address*</label> -->
            <label class="field-label">Registered Business Address*</label>
            <EUIAutocomplete
              ref="autocomplete"
              class="sai-select col-6"
              popup-content-class="sai-select-popup"
              :country-restrictions="['au', 'nz']"
              :placeholder="entityDetails.address"
              dense
              borderless
              behavior="menu"
              dropdown-icon="eva-search-outline"
              no-error-icon
              hide-bottom-space
              :disable="false"
              :clearable="false"
              @input="updatePlace"
            />
          </div>
        </div>
        <QCheckbox label="Trading Address is same as Company Legal Address" v-model="entityDetails.sameAddress" />
        <div class="row" v-if="!entityDetails.sameAddress" style="padding-bottom: 10px">
          <div class="q-pa-xs col-12 col-sm-6">
            <label class="field-label">Trading Address*</label>
            <EUIAutocomplete
              ref="autocomplete2"
              class="primary col-6"
              popup-content-class="sai-select-popup"
              :country-restrictions="['au', 'nz']"
              :placeholder="entityDetails.tradingAddress"
              behavior="menu"
              dropdown-icon="eva-search-outline"
              no-error-icon
              hide-bottom-space
              :disable="false"
              :clearable="false"
              @input="updatePlace2"
            />
          </div>
        </div>
        <div class="row">
          <!-- <InputField label="Company Contact Number" v-model="entityDetails.number" :required="true" type="tel" :length="10" />
          <InputField label="Company Website" v-model="entityDetails.website" /> -->

          <InputField
            v-if="region == 'AU'"
            label="Business Contact Number"
            v-model="entityDetails.number"
            :required="true"
            type="tel"
            :length="10"
          />
          <InputField
            v-if="region == 'NZ'"
            label="Business Contact Number"
            v-model="entityDetails.number"
            :required="true"
            type="tel"
            :minLength="9"
            :maxLength="12"
          />
          <InputField label="Business Website" v-model="entityDetails.website" />

          <!--a new field added but not wiredup with backend yet -->
          <!-- <InputField label="Annual Revenue" v-model="entityDetails.annualRevenue"  />   -->
          <!-- <InputField label="Industry Type" v-model="entityDetails.businessNature" v-if="0" />  removed industry type-->
        </div>
        <div class="q-pt-lg q-pb-sm text-center">
          <QBtn color="primary" type="submit" :loading="loading" no-caps :disable="!disableNext" label="Next" />
        </div>
      </QForm>
    </QExpansionItem>
  </div>
</template>

<script>
import { QBtn, QForm, QSelect, QCheckbox, QExpansionItem } from 'quasar';
import { mapState, mapActions } from 'vuex';
import InputField from '../../components/Atoms/InputField.vue';
import MutateCreateOrUpdateProperty from '../../graphql/mutations/MutateCreateOrUpdateProperty';
import { GLOBAL_ERROR } from '../../components/GlobalError/GlobalError';
import { EUIAutocomplete } from 'eclipx.ui';

export default {
  name: 'EntityDetails',
  components: {
    InputField,
    QForm,
    QCheckbox,
    QBtn,
    QExpansionItem,
    EUIAutocomplete
  },
  props: ['disableCollapse', 'openCollapse'],
  computed: {
    addressQSelectElement() {
      return this.$refs.autocomplete.$el.querySelector('.q-field__input');
    },
    tradingAddressQSelectElement() {
      return this.$refs.autocomplete2?.$el?.querySelector('.q-field__input');
    },
    ...mapState({
      scoreboard: (state) => state.vehicleApplication.vehicleApplication.scoreboard
    }),
    isCompleted() {
      if (this.scoreboard && this.scoreboard.businessDetails && this.scoreboard.businessDetails.entityDetails) return true;
      else return false;
    },
    labelEntityDetails() {
      //return 'Entity Details' + (this.isCompleted ? '' : '');
      // new
      return 'Business Details' + (this.isCompleted ? '' : '');
    },
    disableNext() {
      if (
        this.entityDetails.name &&
        this.entityDetails.address &&
        (this.entityDetails.sameAddress || this.entityDetails.tradingAddress) &&
        this.entityDetails.number &&
        this.entityDetails.streetNo &&
        this.entityDetails.streetName &&
        this.entityDetails.suburb &&
        this.entityDetails.state &&
        this.entityDetails.postCode
      )
        return true;
      else return false;
    },
    region() {
      return this.scoreboard?.currentUser?.region || 'AU';
    }
  },
  created() {
    if (this.scoreboard && this.scoreboard.entityDetails) {
      this.entityDetails.name = this.scoreboard.entityDetails.entityName;
    }
    if (this.scoreboard && this.scoreboard.businessDetails && this.scoreboard.businessDetails.entityDetails) {
      this.entityDetails.address = this.scoreboard.businessDetails.entityDetails.companyLegalAddress;
      this.entityDetails.sameAddress = this.scoreboard.businessDetails.entityDetails.tradingAddressSame;
      this.entityDetails.tradingAddress = this.scoreboard.businessDetails.entityDetails.tradingAddress;
      this.entityDetails.number = this.scoreboard.businessDetails.entityDetails.businessContactNumber;
      this.entityDetails.website = this.scoreboard.businessDetails.entityDetails.businessWebsite;
      this.entityDetails.years = this.scoreboard.businessDetails.entityDetails.yearOfBusiness;
      this.entityDetails.businessNature = this.scoreboard.businessDetails.entityDetails.natureOfBusiness;
      this.entityDetails.streetNo = this.scoreboard.businessDetails.entityDetails.streetNo;
      this.entityDetails.streetName = this.scoreboard.businessDetails.entityDetails.streetName;
      this.entityDetails.suburb = this.scoreboard.businessDetails.entityDetails.suburb;
      this.entityDetails.state = this.scoreboard.businessDetails.entityDetails.state;
      this.entityDetails.postCode = this.scoreboard.businessDetails.entityDetails.postCode;
      setTimeout(() => {
        this.$emit('entityDetailsCompleted');
      });
    }
  },
  mounted() {
    this.openEntityDetails = this.openCollapse;
    // Apply Event Listener for addresses
    const addressElement = this.addressQSelectElement;

    if (addressElement) {
      addressElement.addEventListener('input', (event) => this.handleAddressInputChange(event, this.$refs.autocomplete));
    }
  },
  watch: {
    'openCollapse': function (newValue) {
      this.openEntityDetails = newValue;
    },
    'entityDetails.sameAddress': function (value) {
      if (!value) {
        setTimeout(() => {
          const tradingAddressElement = this.tradingAddressQSelectElement;

          if (tradingAddressElement) {
            tradingAddressElement.addEventListener('input', (event) => this.handleAddressInputChange(event, this.$refs.autocomplete2));
          }
        }, 100);
      } else {
        const tradingAddressElement = this.tradingAddressQSelectElement;

        if (tradingAddressElement) {
          tradingAddressElement.removeEventListener('input', (event) => this.handleAddressInputChange(event, this.$refs.autocomplete2));
        }
      }
    }
  },
  data: function () {
    return {
      entityDetails: {
        name: '',
        address: '',
        sameAddress: true,
        tradingAddress: '',
        streetNo: '',
        streetName: '',
        suburb: '',
        state: '',
        postCode: '',
        country: '',
        countryCode: '',
        subPremise: '',
        number: '',
        website: '',
        years: '',
        businessNature: ''
      },
      openEntityDetails: false,
      loading: false,
      debounceTimeout1: null,
      debounceTimeout2: null,
      addressPreviousValue: '',
      tradingAddressPreviousValue: ''
    };
  },
  methods: {
    ...mapActions({
      updateVehicleApplicationState: 'vehicleApplication/updateVehicleApplicationState'
    }),
    handleAddressInputChange(event, autocompleteRef) {
      // Check if reference is Registered Business Address*
      const isAddressRef = autocompleteRef === this.$refs.autocomplete;

      const currentValue = event?.target?.value;

      // Return if no value found
      if (!currentValue) {
        return;
      }

      const previousWords = isAddressRef ? this.addressPreviousValue.split(' ') : this.tradingAddressPreviousValue.split(' ');
      const currentWords = currentValue.split(' ');

      // Check for autofill or words suddenly became morethan 2
      if (currentWords.length - previousWords.length > 1) {
        const debounceTimeout = isAddressRef ? this.debounceTimeout1 : this.debounceTimeout2;

        if (debounceTimeout) {
          clearTimeout(debounceTimeout);
        }

        const debounceTimeoutKey = isAddressRef ? 'debounceTimeout1' : 'debounceTimeout2';

        this[debounceTimeoutKey] = setTimeout(() => {
          if (isAddressRef) {
            this.addressQSelectElement.focus();
          } else {
            this.tradingAddressQSelectElement.focus();
          }

          this.selectFirstOption();
        }, 1000);
      }

      if (isAddressRef) {
        this.addressPreviousValue = currentValue;
      } else {
        this.tradingAddressPreviousValue = currentValue;
      }
    },
    selectFirstOption() {
      const popupMenu = document.querySelector('.q-menu');

      if (popupMenu) {
        const firstOption = popupMenu.querySelector('.q-item');

        if (firstOption) {
          firstOption.click();
        }
      }
    },
    updatePlace(place) {
      if (place && place.address) {
        this.entityDetails.streetNo = place.address.streetNumber ? place.address.streetNumber : place.address.address;
        this.entityDetails.streetName = place.address.address;
        this.entityDetails.suburb = place.address.suburb;
        this.entityDetails.state = place.address.state;
        this.entityDetails.postCode = place.address.postCode;
        this.entityDetails.country = place.address.country;
        this.entityDetails.countryCode = place.address.countryCode;
        this.entityDetails.subPremise = place.address.subPremise;
        this.entityDetails.address = place.label;
      }
    },
    updatePlace2(place) {
      if (place && place.address) this.entityDetails.tradingAddress = place.label;
    },
    onSubmitEntityDetails: async function () {
      this.loading = true;
      const entityDetails = {
        companyLegalName: this.entityDetails.name,
        companyLegalAddress: this.entityDetails.address,
        tradingAddressSame: this.entityDetails.sameAddress,
        tradingAddress: this.entityDetails.tradingAddress,
        businessContactNumber: this.entityDetails.number,
        businessWebsite: this.entityDetails.website,
        yearOfBusiness: this.entityDetails.years,
        natureOfBusiness: this.entityDetails.businessNature,
        streetNo: this.entityDetails.streetNo,
        streetName: this.entityDetails.streetName,
        suburb: this.entityDetails.suburb,
        state: this.entityDetails.state,
        country: this.entityDetails.country,
        countryCode: this.entityDetails.countryCode,
        subPremise: this.entityDetails.subPremise,
        postCode: this.entityDetails.postCode
      };

      await this.$apollo
        .mutate({
          mutation: MutateCreateOrUpdateProperty,
          variables: {
            applicationId: this.$store.getters['vehicleApplication/vehicleApplication']
              ? this.$store.getters['vehicleApplication/vehicleApplication'].applicationId
              : null,
            params: {
              value: 'entityDetails',
              entityDetails: entityDetails,
              propertyFirst: 'businessDetails',
              propertySecond: 'entityDetails'
            }
          }
        })
        .then((data) => {
          this.updateVehicleApplicationState({
            value: entityDetails,
            propertyFirst: 'businessDetails',
            propertySecond: 'entityDetails'
          });
          setTimeout(() => {
            this.$emit('entityDetailsCompleted', true);
          });
        })
        .catch((error) => {
          let gqlError = error.graphQLErrors[0];
          this.error = gqlError ? gqlError.message : 'Error';
          if (error) {
            this.$euiNotifications.emit({
              notification: GLOBAL_ERROR
            });
          }
        });
      this.loading = false;
    }
  },
  beforeDestroy() {
    // Remove the event listener when the component is destroyed
    const addressElement = this.addressQSelectElement;
    const tradingAddressElement = this.tradingAddressQSelectElement;

    if (addressElement) {
      addressElement.removeEventListener('input', (event) => this.handleAddressInputChange(event, this.$refs.autocomplete));
    }

    if (tradingAddressElement) {
      tradingAddressElement.removeEventListener('input', (event) => this.handleAddressInputChange(event, this.$refs.autocomplete2));
    }
  }
};
</script>
<style lang="sass" scoped>
.EUISelect::v-deep
  input::placeholder
    color: #333333!important
</style>
